import { useCallback, useEffect, useState, useRef } from 'react';
import styles from './Services.module.css';

import { JLLServiceList, JLLServiceCategories } from '../data/JLLServiceList';

import Search from '@mui/icons-material/Search';
import Close from '@mui/icons-material/Close';
import MiniNav from './MiniNav';

const servicesMiniNavLinks = [
    { id: "servicesLinkDesign", link: "#design", linkText: "Design", linkTitle: "View Design Folio", targetUp: true, specialLink: false },
    { id: "servicesLinkIllustration", link: "#illustration", linkText: "Illustration", linkTitle: "View Illustration Folio", targetUp: true, specialLink: false },
    { id: "servicesLinkAbout", link: "#about", linkText: "working with me ↰", linkTitle: "See about me.", targetUp: true, specialLink: true }
]


function Services() {



    const [searchTerm, setSearchTerm] = useState('');
    const [filteredList, setFilteredList] = useState(JLLServiceList.sort(
        (a, b) => {
            let textA = a.title.toLowerCase();
            let textB = b.title.toLowerCase();
            return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
        }
    ));


    const cancelSearch = (e) => {

        if (e.key === "Escape") {
            setSearchTerm("");
            e.target.value = "";
            handleSearch(e);
        }

    }

    const closeSearch = (e) => {
        setSearchTerm("");
        e.target.value = "";
        handleSearch(e);
    }

    const handleSearch = (e) => {

        const value = e.key === "Escape" ? "" : e.target.value;

        if (e.key === "Escape") {
        } else {
            setSearchTerm(value);
        }

        const keywords = value.split(' ').filter(Boolean); // split and filter out empty strings

        const filteredData = JLLServiceList.filter(
            serviceItem => {

                if (value.toString() === "") {
                    return true;
                } else {
                    return keywords.some(searchKeyword =>
                        Object.values(serviceItem).some(item =>
                            serviceItem.title.toLowerCase().includes(searchKeyword.toLowerCase()) ||
                            serviceItem.tags.toString().toLowerCase().includes(searchKeyword.toLowerCase()) ||
                            (serviceItem.category[0] ?
                                (JLLServiceCategories[serviceItem.category[0]] ?
                                    JLLServiceCategories[serviceItem.category[0]].tags.toLowerCase().includes(searchKeyword.toLowerCase()) : null) : null) ||
                            (serviceItem.category[1] ?
                                (JLLServiceCategories[serviceItem.category[1]] ?
                                    JLLServiceCategories[serviceItem.category[1]].tags.toLowerCase().includes(searchKeyword.toLowerCase()) : null) : null) ||
                            (serviceItem.category[2] ?
                                (JLLServiceCategories[serviceItem.category[2]] ?
                                    JLLServiceCategories[serviceItem.category[2]].tags.toLowerCase().includes(searchKeyword.toLowerCase()) : null) : null) ||
                            (serviceItem.category[3] ?
                                (JLLServiceCategories[serviceItem.category[3]] ?
                                    JLLServiceCategories[serviceItem.category[3]].tags.toLowerCase().includes(searchKeyword.toLowerCase()) : null) : null) ||
                            (serviceItem.category[4] ?
                                (JLLServiceCategories[serviceItem.category[4]] ?
                                    JLLServiceCategories[serviceItem.category[4]].tags.toLowerCase().includes(searchKeyword.toLowerCase()) : null) : null)
                        )
                    );
                }
            }).sort(
                (a, b) => {
                    let textA = a.title.toLowerCase();
                    let textB = b.title.toLowerCase();
                    return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
                }
            );

        setFilteredList(filteredData);
    }



    return (

        <div id={"services"} className={styles.services}>
            <MiniNav miniNavLinkArray={servicesMiniNavLinks}/>
            <div className={styles.servicesInfo}>
                <h2 className={styles.servicesTitle}>Services</h2>
                <div className={styles.servicesSearch}>
                    {/*<label for="servicesSearchInput" className={styles.servicesSearchLabel}>Search:</label>*/}
                    <div className={styles.searchIcon} onClick={closeSearch}>{searchTerm.length === 0 ? <Search className={styles.searchIconSVG} /> : <Close className={styles.searchIconSVG} />}</div>
                    <input type="search"
                        placeholder='Search'
                        id="servicesSearchInputField"
                        value={searchTerm}
                        onChange={handleSearch} onKeyDown={cancelSearch}
                        tabIndex={0}
                        title="Search for a service."
                        className={styles.servicesSearchInput} />
                </div>
                <div className={styles.serviceList}>
                    {((searchTerm.length === 1) && (filteredList.length !== 0)) ? 
                     <p className={styles.searchComment}>Here are a few things I can do, based on just the letter '{searchTerm}':</p>
                     : null}
                     {((searchTerm.length > 1) && (filteredList.length !== 0)) ? 
                     <p className={styles.searchComment}>Here are a few things I can do, related to '{searchTerm}':</p>
                     : null}
                    {JLLServiceList ?
                        filteredList.map(item => {
                            return <span id={item.id} className={styles.serviceListItem}
                            ><span className={styles.serviceListItemText}>{item.title}</span></span>
                        }) : null
                    }
                    {filteredList.length === 0 ? <p className={styles.searchComment}>
                        Can't find anything for "{searchTerm.toLowerCase()}". <span className={styles.searchCommentCTA}>Say hey <a
                            className={styles.email} title="Send an email to design@jlliew.com" href="mailto:design@jlliew.com"
                        >design@jlliew.com</a> anyway!</span>
                    </p> : null}
                </div>

            </div>
        </div>



    );
}

export default Services;
